import $ from './app/jquery-shim.js';
import myScript from './scripts.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import Fullpage from './app/fullpage.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';
import ScrollReveal from "scrollreveal"

import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';

// class ScrollReveal {
//   constructor(options){
//     this.options = options;
//   }
//
//   reveal(el, options, duration){
//     $(el).css({
//       visibility: "visible",
//       opacity: 0,
//     })
//     scrollfire( el, function(){
//       // console.log(el);
//       var args = {
//         targets: el,
//         // opacity: 1,
//         // translateY: -options.distance,
//         // duration: 600
//       }
//       args = Object.assign(options,args);
//       anime(args);
//     }, {
//       offset: window.innerHeight/2
//     })
//   }
// }

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    if ($('.c-main-visual').length > 0) {
      // this.Fullpage = new Fullpage();
    }


    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      // console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 951) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          // navText: ['<img src="/wp-content/themes/trinify-html/dist/assets/images/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/trinify-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 36,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          // navText: ['<img src="/wp-content/themes/trinify-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/trinify-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 14,
              stagePadding: 30,
            },
            // breakpoint from 750 up
            750: {
              items: 1,
              stagePadding: 164,
            },
            1070: {
              items: 1,
              stagePadding: 284,
            },
            1280: {
              items: 1,
              stagePadding: 424,
            },
            1601: {
              items: 2,
              center: false,
              stagePadding: 164,
            },
          }
        });
      });
    }

    // modaal
    function modaal() {
      // ====================
      // <HTML>
      // <a href="path/to/image.jpg" class="js-modal-image" data-modaal-desc="My Description">Show</a>
      // or
      // <button data-modaal-content-source="path/to/image.jpg" class="js-modal-image">Show</button>
      // ====================

      $('.js-modal-image').modaal({
        type: 'image'
      });
    }

    //- スクロールリーバル
    function reveal() {
      // function domEach(items, callback) {
      //   if (typeof items === "string") {
      //     var items = $(items);
      //   }
      //   for (var i = 0; i < items.length; i++) {
      //     var item = items[i];
      //     // callback = callback.bind(item)
      //     callback(i, item);
      //   }
      // }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '20';

      sr.reveal(".c-card-study", {
        duration: 600,
        opacity: 1,
        translateY: [baseDistance, 0],
        delay: 200,
        easing: baseEasing,
      }, 600);
      sr.reveal(".c-top-company", {
        duration: 600,
        opacity: 1,
        translateY: [baseDistance, 0],
        delay: 200,
        easing: baseEasing,
      }, 600);
      sr.reveal(".c-top-recruit", {
        duration: 600,
        opacity: 1,
        translateY: [baseDistance, 0],
        delay: 200,
        easing: baseEasing,
      }, 600);
      sr.reveal(".c-top-news", {
        duration: 600,
        opacity: 1,
        translateY: [baseDistance, 0],
        delay: 200,
        easing: baseEasing,
      }, 600);
      sr.reveal(".c-business-partner", {
        duration: 600,
        opacity: 1,
        translateY: [baseDistance, 0],
        delay: 200,
        easing: baseEasing,
      }, 600);
    }

    function slickCarousel() {

      $('.js-slick-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        fade: false,
        asNavFor: '.js-slick-thumb'
      });
      $('.js-slick-thumb').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-slick-main',
        dots: true,
        // arrows: true,
        // appendArrows: $('.js-slick-thumb'),
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          }
        ]
      });
    }


    function fixedDots() {
      if (window.innerWidth > 950) {
        return false;
      }
      var targetDots = document.querySelector('.js-scrollnav');
      let $firstSection = document.getElementById('section_01');
      let $middleSection = document.getElementById('section_02');
      let $lastSection = document.getElementById('section_03');
      let $firstSectionTop = $($firstSection).offset().top;
      let $middleSectionTop = $($middleSection).offset().top;
      let $lastSectionTop = $($lastSection).offset().top;
      let scrollTop = window.pageYOffset;


      if (scrollTop > $firstSectionTop - 80 && scrollTop <= Math.floor($lastSectionTop + 80)) {
        targetDots.style.position = 'fixed';
        targetDots.style.top = '80px';
        targetDots.style.left = '0';
      } else {
        targetDots.style.position = 'absolute';
        targetDots.style.top = '0';
        targetDots.style.left = '0';
      }


      if ($middleSectionTop > scrollTop) {
        for (var i = 0; i < 3; i++) {
          targetDots.children[0].children[i].children[0].classList.remove('is-current');
        }
        targetDots.children[0].children[0].children[0].classList.add('is-current');
      } else if ($lastSectionTop > scrollTop) {
        for (var i = 0; i < 3; i++) {
          targetDots.children[0].children[i].children[0].classList.remove('is-current');
        }
        targetDots.children[0].children[1].children[0].classList.add('is-current');
      } else {
        for (var i = 0; i < 3; i++) {
          targetDots.children[0].children[i].children[0].classList.remove('is-current');
        }
        targetDots.children[0].children[2].children[0].classList.add('is-current');
      }

      window.requestAnimationFrame(fixedDots);
    }


    function sreveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600,mobile:false});
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".c-card-study", {viewFactor: 0.3,scale: 1, duration: 600,origin:'bottom',distance: '20px',}, 100);
      sr.reveal(".c-top-company", {viewFactor: 0.3,scale: 1, duration: 600,origin:'bottom',distance: '20px',}, 100);
      sr.reveal(".c-top-recruit", {viewFactor: 0.3,scale: 1, duration: 600,origin:'bottom',distance: '20px',}, 100);
      sr.reveal(".c-top-news", {viewFactor: 0.3,scale: 1, duration: 600,origin:'bottom',distance: '20px',}, 100);
      sr.reveal(".c-business-partner", {viewFactor: 0.3,scale: 1, duration: 600,origin:'bottom',distance: '20px',}, 100);
      sr.reveal(".l-page-header", {viewFactor: 0.3,scale: 1, duration: 600,delay: 200,origin:'bottom',distance: '0',}, 100);

      function callback (el) {
        setTimeout(function() {
          el.classList.add('is-active');
        }, 200);
      }

      ScrollReveal().reveal('.is-fullwindow', { viewFactor: 0.3, beforeReveal: callback });
    }



    $(function () {
      menuSlide();
      owlCarousel();
      modaal();
      // reveal();
      slickCarousel();
      fixedDots();
      sreveal();
    });
  }
}

window.GApp = new App();
